import { getTokenProperties } from 'APP/Lib/AuthHelpers'

export const USERINFO_TTL_MS = 60_000

const USER_METADATA_KEY = 'https://dialogue/claims/user_metadata'

export type UserInfoData = Record<string, unknown>

export type UserInfoCache = {
  sub: string
  data: UserInfoData
  expiresAt: number
} | null

const getUserInfoCacheSub = (accessToken?: string | null): string | null => {
  if (!accessToken) {
    return null
  }

  const sub = getTokenProperties(accessToken)?.sub

  return typeof sub === 'string' && sub.length > 0 ? sub : null
}

export const getCachedUserInfo = ({
  accessToken,
  forceRefresh = false,
  userInfoCache,
}: {
  accessToken?: string | null
  forceRefresh?: boolean
  userInfoCache: UserInfoCache
}): UserInfoData | null => {
  const sub = getUserInfoCacheSub(accessToken)

  if (sub && !forceRefresh && userInfoCache?.sub === sub && Date.now() < userInfoCache.expiresAt) {
    return userInfoCache.data
  }

  return null
}

export const normalizeUserInfoData = (
  data?: UserInfoData | null
): UserInfoData | null | undefined => {
  if (!data) {
    return data
  }

  const userMetadata = data[USER_METADATA_KEY]

  if (!userMetadata) {
    return data
  }

  const normalizedData = { ...data }
  delete normalizedData[USER_METADATA_KEY]

  return {
    ...normalizedData,
    user_metadata: userMetadata,
  }
}

export const createUserInfoCache = ({
  accessToken,
  data,
}: {
  accessToken?: string | null
  data?: UserInfoData | null
}): UserInfoCache => {
  const sub = getUserInfoCacheSub(accessToken)

  if (!sub || !data) {
    return null
  }

  return {
    sub,
    data,
    expiresAt: Date.now() + USERINFO_TTL_MS,
  }
}
